/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import LegalbirdIoModal from "../../Modal/LegalbirdIoModal";
import React, { useEffect, useState } from "react";
import LegalbirdCall from "../../TwilioVoice/LegalbirdCall";
import ApiClient from "../../../services/ApiClient";
import { useCall } from "../../../provider/CallProvider";
import { CalendlyEvent } from "../../../types/Calendly/CalendlyEvent";
import { BackofficeUser } from "../../../types/BackofficeUser";
import { ProductUnion } from "../../../types/ProductUnion";

type CallModalProps = {
  open: boolean;
  handleClose: Function;
  product: ProductUnion;
};

function CallModal({ product, open, handleClose = () => {} }: CallModalProps) {
  const [calendlyEvent, setCalendlyEvent] = useState<CalendlyEvent | null>(null);
  const [assignedUser, setAssignedUser] = useState<BackofficeUser | null>(null);
  const { activity, call } = useCall();

  useEffect(() => {
    if (!activity) {
      setCalendlyEvent(null);
      return;
    }

    if (activity.calendlyEvent) {
      ApiClient.get(activity.calendlyEvent).then((response) => setCalendlyEvent(response));
    } else {
      setCalendlyEvent(null);
    }

    if (activity.assignedUser && typeof activity.assignedUser === "string") {
      ApiClient.get(activity.assignedUser).then((response) => setAssignedUser(response));
    } else if (activity.assignedUser && typeof activity.assignedUser === "object") {
      setAssignedUser(activity.assignedUser);
    } else {
      setCalendlyEvent(null);
    }
  }, [activity]);

  if (!activity && !calendlyEvent && !assignedUser) {
    return null;
  }

  return (
    <LegalbirdIoModal
      handleClose={handleClose}
      open={open}
      title={"Anrufen"}
      disableBackdropClick={true}
      hideCloseButton={true}
      cancelButtonLabel={call === null ? "Schliessen" : "Minimieren"}
      keepMounted={call !== null}
    >
      <LegalbirdCall product={product} calendlyEvent={calendlyEvent} />
    </LegalbirdIoModal>
  );
}

export default CallModal;
